<template>
  <div
    v-show="isActive"
    v-uni-id="name"
    v-uni-aria-labelledby="`${name}__item`"
    role="tabpanel"
    :class="`slds-tabs_${variant}__content`"
  >
    <slot :tab="this"></slot>
  </div>
</template>

<script>
/* eslint-disable */
// import { createRoute, isSameRoute } from 'vue-router';
import { createUniqIdsMixin } from 'vue-uniq-ids';
import getUniqId from 'vue-uniq-ids/src/get-uniq-id';

export default {
  inject: {
    // Inject variant from Tabs.vue
    variant: { default: 'default' },
  },
  props: {
    name: { type: String, required: true },
    title: { type: String, required: true },
    titleClass: { type: Object },
    badge: { type: [String, Number] },
    disabled: { type: Boolean },
    href: { type: String },
    target: { type: String },
    routeTo: { type: [String, Object] },
    // Callback function executed before tab switch. Returns a boolean that,
    // if false, tab will not be activated.
    beforeChange: { type: Function },
  },
  data() {
    return {
      routeLocation: undefined,
      routeIsActive: undefined,
      isDisabled: this.disabled,
      isActive: false,
    };
  },
  computed: {
    activeHref() {
      if (this.href) {
        return this.href;
      }
      if (this.routeTo) {
        return this.routeHref();
      }
      const targetId = getUniqId(
        this.$options.uniqIdsConfig.scope,
        this.name,
        this.$options.uniqIdsConfig
      );
      return `#${targetId}`;
    },
  },
  watch: {
    disabled(val) {
      this.isDisabled = val;
    },
  },
  created() {
    // inherit shared scope for unique ids from parent
    this.$options.uniqIdsConfig = this.$parent.$options.uniqIdsConfig;
  },
  methods: {
    routeHref() {
      /* const router = this.$router;
      const current = this.$route;
      const { location, route, href } = router.resolve(
        this.routeTo,
        current,
        false
      );
      const compareTarget = location.path
        ? createRoute(null, location, null, router)
        : route;
      this.routeIsActive = isSameRoute(current, compareTarget);
      this.routeLocation = location; */
      return href;
    },
  },
  mixins: [createUniqIdsMixin({ scope: false })],
};
</script>
